import { useTranslation } from "react-i18next"
import { Check } from "@phosphor-icons/react"
import { Chip } from "@/components/ui/chip"
import { TooltipContent, TooltipCustom, TooltipPortal, TooltipTrigger } from "@/components/ui/tooltip"
import { cn } from "@/lib/utils"

type HealthInsuranceCardNumberMissingToggleProps = React.ComponentPropsWithoutRef<typeof Chip>

const HealthInsuranceCardNumberMissingToggle = ({ ...props }: HealthInsuranceCardNumberMissingToggleProps) => {
  const { t } = useTranslation()

  return (
    <TooltipCustom>
      <TooltipTrigger asChild>
        <Chip
          {...props}
          data-state={props.checked && "checked"}
          className={cn(
            "h-8",
            "data-disabled:bg-surface-disabled data-disabled:text-on-surface-disabled! data-disabled:hover:bg-surface-disabled data-disabled:cursor-not-allowed data-disabled:border-none",
          )}>
          <div className="flex items-center gap-0.5">
            <Check
              className={cn("overflow-hidden transition-all duration-200", `w-${props.checked ? "5" : "0"}`)}
              size={20}
            />
            <div className="truncate px-1.5">{t("patient.list.missingHealthCardNumberLabel")}</div>
          </div>
        </Chip>
      </TooltipTrigger>
      {props.disabled && (
        <TooltipPortal>
          <TooltipContent side="bottom" align="start">
            {t("patient.list.functionalityNotAvailable")}
          </TooltipContent>
        </TooltipPortal>
      )}
    </TooltipCustom>
  )
}

export { HealthInsuranceCardNumberMissingToggle }
